import { State } from 'src/types'
// 背面の描画
import { lace } from 'src/features/brands/yellStory/canvas/glove/back/lace'
import { lining } from 'src/features/brands/yellStory/canvas/glove/back/lining'
import { littleHook } from 'src/features/brands/yellStory/canvas/glove/back/hooks/littleHook'
import { thumbHook } from 'src/features/brands/yellStory/canvas/glove/back/hooks/thumbHook'
import { brandLabelDrawerForGlove } from 'src/features/brands/yellStory/canvas/common/useCanvasHelper'
import { webOfGloveBackDrawer } from 'src/features/brands/yellStory/canvas/glove/back/web/useCanvasWebsBack'
import {
  directLogo1EmbroideryBandDrawer,
  directLogo1EmbroideryMiddleFingerDrawer,
  directLogo1EmbroideryRingFingerDrawer,
  liningDirectLogo2EmbroideryDrawer,
  liningEmbroideryDrawer,
  middleFingerDirectLogo2EmbroideryDrawer,
  nonThumbEmbroideryDrawer,
  ringFingerDirectLogo2EmbroideryDrawer
} from 'src/features/brands/yellStory/canvas/common/back/useCanvasEmbroideries'
import { laceOfWristBeltCrossDrawer } from 'src/features/brands/yellStory/canvas/glove/back/lace/laceOfWristBeltFix'
import { canvasResetter } from 'src/features/brands/atoms/canvas/common/canvasResetter'
import { yellStoryBeltBackStyleDrawer } from 'src/features/brands/yellStory/canvas/glove/back/backStyles/yellStoryBackStyleDrawer'

export const ysrCanvasGloveBack = (ctx: CanvasRenderingContext2D, state: State): void => {
  const needCatchFaceWrap = !state.baseModel?.isUBack || false
  // リセット
  canvasResetter(ctx)
  // 裏革
  lining(ctx, state.linings?.color)
  liningDirectLogo2EmbroideryDrawer(ctx, state.ysrDirectLogo2Position, state.ysrDirectLogo2Color)
  // 平裏の刺繍描画1段目
  liningEmbroideryDrawer(ctx, state.embroideries, 'first')
  // 平裏の刺繍描画2段目
  liningEmbroideryDrawer(ctx, state.embroideries, 'second')
  // バックスタイルの描画(ハミダシ,親指刺繍含, 指パッド)
  yellStoryBeltBackStyleDrawer(ctx, state, needCatchFaceWrap)
  // 中指への刺繍
  nonThumbEmbroideryDrawer(ctx, 'middleFinger', state.embroideries)
  middleFingerDirectLogo2EmbroideryDrawer(ctx, state.ysrDirectLogo2Position, state.ysrDirectLogo2Color)
  // 薬指への刺繍
  nonThumbEmbroideryDrawer(ctx, 'ringFinger', state.embroideries)
  ringFingerDirectLogo2EmbroideryDrawer(ctx, state.ysrDirectLogo2Position, state.ysrDirectLogo2Color)
  // 小指への刺繍
  nonThumbEmbroideryDrawer(ctx, 'childFinger', state.embroideries)
  // ウェブの描画
  webOfGloveBackDrawer(ctx, state)
  // 革紐
  lace(ctx, state.lace?.color)

  laceOfWristBeltCrossDrawer(ctx, state.lace?.color, false)
  // ラベル描画
  if (state.ysrDirectLogo1Position.value === 'band') {
    directLogo1EmbroideryBandDrawer(ctx, state.ysrDirectLogo1Position, state.ysrDirectLogo1MainColor, state.ysrDirectLogo1EdgeColor, state.listBelt)
  } else {
    brandLabelDrawerForGlove(ctx, state)
  }
  directLogo1EmbroideryMiddleFingerDrawer(
    ctx,
    state.ysrDirectLogo1Position,
    state.ysrDirectLogo1MainColor,
    state.ysrDirectLogo1EdgeColor,
    state.middleIndex
  )
  directLogo1EmbroideryRingFingerDrawer(
    ctx,
    state.ysrDirectLogo1Position,
    state.ysrDirectLogo1MainColor,
    state.ysrDirectLogo1EdgeColor,
    state.ringMiddle
  )

  // 小指掛け紐
  littleHook(ctx, state.littleHook?.color, 25, 240, -10, 0.7)
  // 親指掛け紐
  thumbHook(ctx, state.thumbHook?.color, 110, -310, 15) // 先端
  thumbHook(ctx, state.thumbHook?.color, -14, 30, 0) //手元
  // circleHollowOutEmbroideryDrawer(ctx, state.embroideries)
}
